import { render, staticRenderFns } from "./LocalsPerformance.vue?vue&type=template&id=59c8ca41&scoped=true"
import script from "./LocalsPerformance.vue?vue&type=script&lang=js"
export * from "./LocalsPerformance.vue?vue&type=script&lang=js"
import style0 from "./LocalsPerformance.vue?vue&type=style&index=0&id=59c8ca41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8ca41",
  null
  
)

export default component.exports